/**
 * Custom event handler for GA.
 */

import ReactGA from 'react-ga';
import _ from 'lodash';

/**
 * ReactGaEvent - Ga event tracking.
 * @param {string} category
 * @param {string} action
 */
export const ReactGaEvent = (category, action) => {
  let user = 'no-user';

  let session = localStorage.getItem('session');
  if (session) {
    session = JSON.parse(session);
    user = session.user;
  }

  ReactGA.event({
    category: _.trim(category, '/'),
    action: _.trim(action, '/'),
    label: user,
  });
};

export default ReactGaEvent;



// WEBPACK FOOTER //
// ./app/react-ga-event.js